var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-cmp-wrapper"},[_c('div',{staticClass:"center-cmp",attrs:{"id":"center-cmp"}}),_c('div',{staticClass:"equipment__count"},[_c('p',[_vm._v("设备总数："+_vm._s(_vm.equipmentCount.sbamount))])])])}
var staticRenderFns = []

export { render, staticRenderFns }